import { useQuery } from '@tanstack/react-query';
import { partnerApi, type Tenant } from '../../lib/api';

type TenantRosterEntry = Pick<Tenant, 'id' | 'name' | 'externalId'>;

export async function fetchAllTenants(): Promise<TenantRosterEntry[]> {
  const allTenants: TenantRosterEntry[] = [];
  let cursor: string | null | undefined;
  let hasNextPage = true;

  while (hasNextPage) {
    const response = await partnerApi.getTenants(false, {
      limit: 100,
      fields: ['id', 'name', 'externalId'],
      cursor: cursor ?? undefined,
    });

    const results = response.data?.results ?? [];
    allTenants.push(...results);

    cursor = response.data?.pagination?.cursor;
    hasNextPage = response.data?.pagination?.hasNextPage ?? false;
  }

  return allTenants;
}

export function useTenants() {
  return useQuery({
    queryKey: ['tenants'],
    queryFn: fetchAllTenants,
    staleTime: 5 * 60 * 1000,
  });
}
